const Config={

  // base_url: "https://schoolroomhelp.net/api",
  // home_url:"https://schoolroomhelp.net",
  // sadmin_url: "https://sadmin.20thfloor.com",
  // student_url: "https://student.20thfloor.com",
  // tutor_url: "https://pro.20thfloor.com",

	// base_url: 'http://localhost:8000/api',
	// home_url:'http://localhost:8000',
  	// sadmin_url: 'http://localhost:3001',
  	// student_url: 'http://localhost:3002',
  	// tutor_url: 'http://localhost:3003',

  	base_url: "https://schoolroomhelp.net/api",
  	home_url:"https://schoolroomhelp.net",
  	sadmin_url: "https://sadmin.schoolroomhelp.net",
  	student_url: "https://student.schoolroomhelp.net",
  	tutor_url: "https://pro.schoolroomhelp.net",

};
 export default Config
